import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustSignals = () => {
  const certifications = [
    {
      icon: "Shield",
      title: "ISO 27001 Certified",
      description: "Information security management"
    },
    {
      icon: "Lock",
      title: "GDPR Compliant",
      description: "Data protection & privacy"
    },
    {
      icon: "CheckCircle",
      title: "Ministry Approved",
      description: "Chinese education authority"
    },
    {
      icon: "Award",
      title: "Trusted by 50K+ Students",
      description: "Worldwide recognition"
    }
  ];

  const statistics = [
    {
      value: "98%",
      label: "Success Rate",
      icon: "TrendingUp"
    },
    {
      value: "150+",
      label: "Partner Universities",
      icon: "Building2"
    },
    {
      value: "24/7",
      label: "Support Available",
      icon: "Headphones"
    },
    {
      value: "50K+",
      label: "Applications Processed",
      icon: "FileCheck"
    }
  ];

  return (
    <div className="space-y-6">
      <div className="bg-card rounded-lg p-6 md:p-8 shadow-warm border border-border">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-10 h-10 bg-success/10 rounded-full flex items-center justify-center">
            <Icon name="ShieldCheck" size={24} color="var(--color-success)" />
          </div>
          <div>
            <h2 className="text-lg md:text-xl font-heading font-semibold text-foreground">
              Trusted & Secure
            </h2>
            <p className="text-xs md:text-sm text-muted-foreground font-caption">
              Your data is protected
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {certifications?.map((cert, index) => (
            <div
              key={index}
              className="flex items-start gap-3 p-4 bg-muted/30 rounded-md hover:bg-muted/50 transition-smooth"
            >
              <div className="w-10 h-10 bg-primary/10 rounded-full flex items-center justify-center flex-shrink-0">
                <Icon name={cert?.icon} size={20} color="var(--color-primary)" />
              </div>
              <div className="min-w-0">
                <h3 className="text-sm font-medium text-foreground mb-1">
                  {cert?.title}
                </h3>
                <p className="text-xs text-muted-foreground font-caption">
                  {cert?.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="bg-gradient-to-br from-primary/5 to-accent/5 rounded-lg p-6 md:p-8 border border-primary/10">
        <h2 className="text-lg md:text-xl font-heading font-semibold text-foreground mb-6 text-center">
          Platform Statistics
        </h2>

        <div className="grid grid-cols-2 gap-4">
          {statistics?.map((stat, index) => (
            <div
              key={index}
              className="text-center p-4 bg-card rounded-lg shadow-warm-sm"
            >
              <div className="w-12 h-12 bg-accent/10 rounded-full flex items-center justify-center mx-auto mb-3">
                <Icon name={stat?.icon} size={24} color="var(--color-accent)" />
              </div>
              <p className="text-2xl md:text-3xl font-heading font-bold text-primary mb-1 data-text">
                {stat?.value}
              </p>
              <p className="text-xs md:text-sm text-muted-foreground font-caption">
                {stat?.label}
              </p>
            </div>
          ))}
        </div>
      </div>
      <div className="bg-card rounded-lg p-6 border border-border">
        <div className="flex items-start gap-3">
          <Icon name="Info" size={20} color="var(--color-primary)" className="flex-shrink-0 mt-1" />
          <div>
            <h3 className="text-sm font-medium text-foreground mb-2">
              Why Choose ChineseLangApp?
            </h3>
            <ul className="space-y-2 text-xs md:text-sm text-muted-foreground font-caption">
              <li className="flex items-start gap-2">
                <Icon name="Check" size={16} color="var(--color-success)" className="flex-shrink-0 mt-0.5" />
                <span>Direct partnerships with top Chinese universities</span>
              </li>
              <li className="flex items-start gap-2">
                <Icon name="Check" size={16} color="var(--color-success)" className="flex-shrink-0 mt-0.5" />
                <span>Streamlined application process with expert guidance</span>
              </li>
              <li className="flex items-start gap-2">
                <Icon name="Check" size={16} color="var(--color-success)" className="flex-shrink-0 mt-0.5" />
                <span>Secure document management and verification</span>
              </li>
              <li className="flex items-start gap-2">
                <Icon name="Check" size={16} color="var(--color-success)" className="flex-shrink-0 mt-0.5" />
                <span>24/7 multilingual support team</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrustSignals;